import { render } from "./performance-appraisal-modal.vue?vue&type=template&id=6f5f23e9"
import script from "./performance-appraisal-modal.vue?vue&type=script&lang=js"
export * from "./performance-appraisal-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__